import { useState } from "react";
import MuiCheckbox from "./MuiCheckbox";
import CartContainer from "./CartContainer";

export interface ProductFull {
    id: number;
    code: string;
    name: string;
    link: string;
    image: string;

    pack: string;
    price: string;

    qty: number;
    max: number;

    checked: boolean;
    important: boolean;

    discount?: number;
    badges?: string[];
}

export interface StoreFull {
    id: number;
    name: string;
    link: string;
    logo: string;

    voucherText: string;

    checked: boolean;
    products: ProductFull[];
}

export type Store = StoreFull;

export default function CartAction() {
    const [stores, setStores] = useState<StoreFull[]>([
        {
            id: 1,
            name: "Dược Phẩm MEDX",
            link: "/seller/duoc-pham-medx",
            logo: "https://gcs.buymed.com/thuocsi-live/web/static/images/logo_medx.png",
            voucherText: "Mã giảm giá 5.5% - tối đa 1.250.000đ",
            checked: true,

            products: [
                {
                    id: 11,
                    code: "MEDX.TANGANIL500",
                    name: "Tanganil 500mg Pierre Fabre (H/30v)",
                    link: "/product/tanganil-500",
                    image: "https://gcs.buymed.com/thuocsi-live/images/2024d52b50ff9f68cb3e2363bca5787b?width=150&quality=80",

                    pack: "Hộp 3 vỉ x 10 viên nén",
                    price: "137.400",

                    qty: 1,
                    max: 155,

                    checked: true,
                    important: false,

                    discount: 4,
                    badges: [
                        "https://gcs.buymed.com/thuocsi-live/internal/cms/2024e1a6ffa3d0111cad282d9eeed6f3Tag_Label_-_Icon+Text-5.svg",
                        "https://gcs.buymed.com/thuocsi-live/internal/cms/20248548017b06b42bd161800e69f58aCOMBO_Tag_Label__CARD_NGANG_(3)_(1).svg"
                    ]
                },
                {
                    id: 111,
                    code: "MEDX.TANGANIL500",
                    name: "Tanganil 500mg Pierre Fabre (H/30v)",
                    link: "/product/tanganil-500",
                    image: "https://gcs.buymed.com/thuocsi-live/images/2024d52b50ff9f68cb3e2363bca5787b?width=150&quality=80",

                    pack: "Hộp 3 vỉ x 10 viên nén",
                    price: "137.400",

                    qty: 1,
                    max: 155,

                    checked: true,
                    important: false,

                    discount: 4,
                    badges: [
                        "https://gcs.buymed.com/thuocsi-live/internal/cms/2024e1a6ffa3d0111cad282d9eeed6f3Tag_Label_-_Icon+Text-5.svg",
                        "https://gcs.buymed.com/thuocsi-live/internal/cms/20248548017b06b42bd161800e69f58aCOMBO_Tag_Label__CARD_NGANG_(3)_(1).svg"
                    ]
                }
            ]
        },

        {
            id: 2,
            name: "Opella (Sanofi) Việt Nam",
            link: "/flagship-store/sanofi-viet-nam",
            logo: "https://gcs.buymed.com/thuocsi-live/images/2024d52b50ff9f68cb3e2363bca5787b?width=150&quality=80",
            voucherText: "Mã giảm giá lên đến 31.000.000đ",
            checked: false,

            products: [
                {
                    id: 21,
                    code: "SANOFI.MAGNEB6",
                    name: "Combo 160 Magne B6 Corbiere",
                    link: "/product/magne-b6",

                    image: "https://gcs.buymed.com/thuocsi-live/images/2024d52b50ff9f68cb3e2363bca5787b?width=150&quality=80",
                    pack: "Hộp 5 vỉ x 10 viên nén bao phim",

                    price: "15.614.100",

                    qty: 3,
                    max: 1000,

                    checked: false,
                    important: true,

                    discount: 4,
                    badges: [
                        "https://gcs.buymed.com/thuocsi-live/internal/cms/2024e1a6ffa3d0111cad282d9eeed6f3Tag_Label_-_Icon+Text-5.svg",
                        "https://gcs.buymed.com/thuocsi-live/internal/cms/20248548017b06b42bd161800e69f58aCOMBO_Tag_Label__CARD_NGANG_(3)_(1).svg"
                    ]
                }
            ]
        }
    ]);

    // tổng sản phẩm
    const allProducts = stores.flatMap(s => s.products);
    const total = allProducts.length;
    const selected = allProducts.filter(p => p.checked).length;

    const allChecked = selected === total && total > 0;
    const indeterminate = selected > 0 && selected < total;

    // toggle tất cả
    const toggleAll = () => {
        setStores(prev =>
            prev.map(store => ({
                ...store,
                checked: !allChecked,
                products: store.products.map(p => ({
                    ...p,
                    checked: !allChecked
                }))
            }))
        );
    };

    // toggle shop
    const toggleStore = (storeId: number) => {
        setStores(prev =>
            prev.map(store =>
                store.id === storeId
                    ? {
                        ...store,
                        checked: !store.checked,
                        products: store.products.map(p => ({
                            ...p,
                            checked: !store.checked
                        }))
                    }
                    : store
            )
        );
    };

    // toggle product
    const toggleProduct = (storeId: number, productId: number) => {
        setStores(prev =>
            prev.map(store =>
                store.id === storeId
                    ? {
                        ...store,
                        products: store.products.map(p =>
                            p.id === productId
                                ? { ...p, checked: !p.checked }
                                : p
                        ),
                        checked: store.products.every(p =>
                            p.id === productId ? !p.checked : p.checked
                        )
                            ? false
                            : store.checked
                    }
                    : store
            )
        );
    };

    // qty update
    const changeQty = (storeId: number, productId: number, d: number) => {
        setStores(prev =>
            prev.map(store =>
                store.id === storeId
                    ? {
                        ...store,
                        products: store.products.map(p =>
                            p.id === productId
                                ? { ...p, qty: Math.max(1, p.qty + d) }
                                : p
                        )
                    }
                    : store
            )
        );
    };

    // remove product
    const removeProduct = (storeId: number, productId: number) => {
        setStores(prev =>
            prev.map(store =>
                store.id === storeId
                    ? {
                        ...store,
                        products: store.products.filter(p => p.id !== productId)
                    }
                    : store
            )
        );
    };

    // toggle important
    const toggleImportant = (storeId: number, productId: number) => {
        setStores(prev =>
            prev.map(store =>
                store.id === storeId
                    ? {
                        ...store,
                        products: store.products.map(p =>
                            p.id === productId
                                ? { ...p, important: !p.important }
                                : p
                        )
                    }
                    : store
            )
        );
    };

    return (
        <div className="styles_cartContainer__uJI18">

            {/* Top Action bar giống hình */}
            <div className="styles_cartAction__yOdw7">
                <p className="styles_cartActionText__n8puB">
                    {selected}/{total} sản phẩm đã chọn
                </p>

                <div className="styles_cartActionRight__OVpce">
                    <div role="button" className="styles_cartRemoveAll__gUrix styles_outline__E_cox">
                        <div className="styles_cartRemoveIcon__q4_Ak">
                            <span style={{ boxSizing: 'border-box', display: 'inline-block', overflow: 'hidden', width: 'initial', height: 'initial', background: 'none', opacity: 1, border: 0, margin: 0, padding: 0, position: 'relative', maxWidth: '100%' }}>
                                <span style={{ boxSizing: 'border-box', display: 'block', width: 'initial', height: 'initial', background: 'none', opacity: 1, border: 0, margin: 0, padding: 0, maxWidth: '100%' }}>
                                    <img alt="" aria-hidden="true" src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2717%27%20height=%2717%27/%3e" style={{ display: 'block', maxWidth: '100%', width: 'initial', height: 'initial', background: 'none', opacity: 1, border: 0, margin: 0, padding: 0 }} />
                                </span>
                                <img data-origin-url="https://cdn-web-next.thuocsi.vn/images/cart/trash_green_icon.svg" src="https://cdn-web-next.thuocsi.vn/images/cart/trash_green_icon.svg" decoding="async" data-nimg="intrinsic" style={{ position: 'absolute', inset: 0, boxSizing: 'border-box', padding: 0, border: 'none', margin: 'auto', display: 'block', width: 0, height: 0, minWidth: '100%', maxWidth: '100%', minHeight: '100%', maxHeight: '100%' }} />
                            </span>
                        </div>
                        <p className="styles_cartRemoveText__beh15 hidden-1199">Xoá khỏi giỏ hàng</p>
                    </div>

                    <label
                        className="styles_cartSelectAll__3_iRm MuiFormControlLabel-labelPlacementStart"
                        onClick={toggleAll}
                    >
                        <MuiCheckbox
                            checked={allChecked}
                            indeterminate={indeterminate}
                            onChange={toggleAll}
                        />
                        <span>Chọn tất cả</span>
                    </label>

                </div>
            </div>

            {/* List store + products */}
            <CartContainer
                stores={stores}
                toggleStore={toggleStore}
                toggleProduct={toggleProduct}
                changeQty={changeQty}
                removeProduct={removeProduct}
                toggleImportant={toggleImportant}
            />
        </div>
    );
}
